import CryptoJS from 'crypto-js'

export default{
    encrypt(word){
        if(!word) return '';
        let key =CryptoJS.enc.Utf8.parse('ga2sme4wwyb5ga2sme4wwyb5');
        let iv = CryptoJS.enc.Utf8.parse('ga2sme4wwyb5');

        let srcs = CryptoJS.enc.Utf8.parse(word)
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })
        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
    },
    decrypt(word){
        if(!word) return '';
        let key =CryptoJS.enc.Utf8.parse('ga2sme4wwyb5ga2sme4wwyb5');
        let iv = CryptoJS.enc.Utf8.parse('ga2sme4wwyb5');

        let base64 = CryptoJS.enc.Base64.parse(word);
        let src = CryptoJS.enc.Base64.stringify(base64);

        var decrypt = CryptoJS.AES.decrypt(src, key, {
            iv: iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    }

}